import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { Grid } from '@material-ui/core';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
  createStyles({
    container: {
      minHeight: '100%',
    },
    sidebar: {
      backgroundColor: theme.palette.common.white,
    },
    sidebarContainer: {
      padding: '0 50px',
    },
    centered: theme.mixins.yAxisCenter,
    sticky: theme.mixins.sticky,
    main: {
      backgroundColor: theme.custom.palette.grey4,
    },
    mainContainer: theme.mixins.yAxisCenter,
  });

interface IProps extends WithStyles<typeof styles> {
  sidebar: ReactNode;
  main: ReactNode;
  sticky?: boolean;
  offset?: number;
}

const Full2Column: FC<IProps> = ({ classes, sidebar, main, sticky, offset }) => {
  const sidebarContainerStyle = sticky && offset ? { top: offset } : {};
  const sidebarContainerClasses = classNames(classes.sidebarContainer, {
    [classes.sticky]: sticky,
    [classes.centered]: !sticky,
  });

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} md={4} className={classes.sidebar}>
        <Grid container className={sidebarContainerClasses} style={sidebarContainerStyle}>
          <Grid item xs={12}>
            {sidebar}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={8} className={classes.main}>
        <Grid container className={classes.mainContainer}>
          <Grid item xs={12}>
            {main}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

Full2Column.defaultProps = {
  sticky: false,
};

export default withStyles(styles)(Full2Column);
